<template>
	<div>
		<div class="container hidden-xs">
			<b-breadcrumbs :items="breadcrumbs"/>
		</div>
		<section class="container">
			<div class="row">
				<div class="col-xs-12">
					<h1>Downloads</h1>
					<div class="page-summary-container">
						<div class="page-summary-text">
							View users who have downloaded files
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12">
					<div class="input-group">
						<input
							v-model="searchTerm"
							type="text"
							class="form-control"
							style="height:40.25px;"
							placeholder="Search by regulation"
							@keyup.enter="getDownloads"
						>
						<span class="input-group-btn">
							<b-btn class="btn-primary" @click="getDownloads">
								<i class="material-icons">search</i>
							</b-btn>
						</span>
					</div>
				</div>
			</div>
			<template v-if="loading">
				<div class="row">
					<div class="col-xs-12">
						<div class="container loading-container">
							<img class="section-loader" src="@/assets/images/iadsa-section-loader-admin.gif"/>
						</div>
					</div>
				</div>
			</template>
			<template v-else-if="downloads && downloads.length > 0">
				<div class="table-responsive">
					<table class="table">
						<thead>
							<tr>
								<td colspan="2">
									<span class="h4">Name</span>
								</td>
								<td colspan="2">
									<span class="h4">Regulation</span>
								</td>
								<td colspan="2">
									<span class="h4">Group</span>
								</td>
								<td colspan="2">
									<span class="h4">Language</span>
								</td>
								<td colspan="2">
									<span class="h4">Downloaded at</span>
								</td>
							</tr>
						</thead>
						<tbody>
							<template
								v-for="download in downloads"
							>
								<tr :key="download.id">
									<td colspan="2">{{ download.user.name }}</td>
									<td colspan="2">{{ download.file.resource.title }}</td>
									<td colspan="2">{{ download.file.group.name }}</td>
									<td colspan="2">{{ download.file.language }}</td>
									<td colspan="2">{{ download.downloaded_at }}</td>
								</tr>
							</template>
						</tbody>
					</table>
				</div>
			</template>
			<template v-else>
				<div class="row">
					<div class="col-xs-12">
						<div class="container center">
							<h2>No results found</h2>
						</div>
					</div>
				</div>
			</template>
			<div class="row">
				<div class="col-xs-12">
					<div class="pagination-container">
						<b-pagination
							v-if="pagination && pagination.totalPages > 1"
							v-model="pagination.page"
							:total-page="pagination.totalPages"
						/>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<style lang="less" scoped>
	.loading-container {
		text-align: center;
	}
	.section-loader {
		max-width: 200px;
		height: auto;
		margin: 30px auto;
	}
</style>

<script>
import { mapGetters } from 'vuex';
import languages from 'language-list';
import { flow, map } from 'lodash/fp';
import moment from 'moment';

export default {
	created() {
		this.getDownloads();
	},
	data() {
		return {
			searchTerm: null,
			downloads: null,
			pagination: {
				page: 1
			},
			loading: false
		};
	},
	computed: {
		...mapGetters({ getBreadcrumbs: 'breadcrumbs' }),
		breadcrumbs() {
			return this.getBreadcrumbs;
		}
	},
	methods: {
		async getDownloads(params) {
			this.loading = true;
			const { searchTerm } = this;

			const { data: { data: downloads, pagination } } = await this.$axios.get('/download', {
				params: {
					searchTerm,
					page: this.pagination.page,
					...params
				}
			});

			const state = flow(
				map(({ file, user, downloaded_at: downloadedAt, ...rest }) => ({
					downloaded_at: moment(downloadedAt).format('DD/MM/YYYY HH:mm:ss'),
					file: {
						language: languages().getLanguageName(file.language),
						group: {
							name: file.group.name
						},
						resource: {
							title: file.resource.title
						}
					},
					user: {
						name: `${user.title}. ${user.first_name} ${user.last_name}`
					},
					...rest
				}))
			)(downloads);
			this.$set(this, 'downloads', state);
			this.$set(this, 'pagination', pagination);
			this.loading = false;
		}
	},
	watch: {
		'pagination.page': async function pageWatcher() {
			await this.getDownloads();
		}
	},
};
</script>
